import { useState, useEffect } from 'react'
import api from '../../services/api'

export default function AdminDashboard() {
  const [stats, setStats] = useState(null)

  useEffect(() => { api.get('/admin/sa/stats').then(r => setStats(r.data)) }, [])

  if (!stats) return <div className="loading-fullscreen"><div className="spinner" /></div>

  return (
    <div className="page">
      <h1 className="text-2xl font-bold" style={{ marginBottom: 6 }}>📊 Dashboard del SaaS</h1>
      <p className="text-muted" style={{ marginBottom: 24 }}>Vista general del negocio</p>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-card-label">Empresas totales</div>
          <div className="stat-card-value">{stats.empresas.total}</div>
          <div className="stat-card-trend text-success">{stats.empresas.activas} activas</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">En trial</div>
          <div className="stat-card-value">{stats.empresas.trial}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">Usuarios totales</div>
          <div className="stat-card-value">{stats.usuariosTotal}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">Números WhatsApp</div>
          <div className="stat-card-value">{stats.sesionesTotal}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">Contactos totales</div>
          <div className="stat-card-value">{stats.contactosTotal.toLocaleString()}</div>
        </div>
        <div className="stat-card" style={{ background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)', color: 'white' }}>
          <div className="stat-card-label" style={{ color: 'rgba(255,255,255,0.85)' }}>MRR (mensual)</div>
          <div className="stat-card-value" style={{ color: 'white' }}>${stats.mrr}</div>
          <div className="stat-card-trend" style={{ color: 'rgba(255,255,255,0.85)' }}>Ingreso mensual recurrente</div>
        </div>
      </div>
    </div>
  )
}
